import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import GlobalHelper from "../../../common/GlobalHelper"
import Icon from "../../../common/icon/icon.component"
import Contact from "../../../state/contact/models/contact"

type OwnProps = {
    contact : Contact,
}


const EmailLink = (props : OwnProps) => {
    return <p className={"m-0"}>
        <a href={"mailto:" + props.contact.getEmail()}>
            {props.contact.getEmail()}
        </a>
        {!GlobalHelper.validateEmail(props.contact.getEmail()) && <div className="text-danger">
            <small>
                <Icon value={"exclamation"} className={"mr-1"}/>
                <FormattedMessage
                    id="customer.view.email_invalid"
                    defaultMessage="Contact's email is invalid."
                />
            </small>
        </div>
        }
    </p>
}

export default injectIntl(EmailLink)


// WEBPACK FOOTER //
// ./src/quote/project/component/EmailLink.tsx